import { RestartAlt } from '@mui/icons-material';
import MomentUtils from '@mui/lab/AdapterMoment';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { IconButton, InputAdornment, InputLabel, TextField } from '@mui/material';
import moment, { Moment, MomentInput } from 'moment';
import React, { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarIcon } from 'components/CustomIcons';

type InputLabelProps = {
  label: ReactNode;
  name: string;
  id: string;
  placeholder: string;
  onchange: (name: string, date: Moment | null) => void | null;
  required?: boolean;
  value: string | null | undefined;
  min?: string | null;
  max?: string | null;
  classNameLabel?: string;
  disabled?: boolean;
  canEmpty?: boolean;
  showError?: boolean;
  variant?: any;
  reset?: Moment | null;
};
const InputDate = (props: InputLabelProps) => {
  const {
    label,
    name,
    id,
    placeholder,
    onchange,
    required = false,
    value,
    min,
    max,
    disabled = false,
    canEmpty = false,
    showError = false,
    variant,
  } = props;
  const [t] = useTranslation();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [isError, setIsError] = useState(false);
  const userLocale = navigator.language || 'fr-FR';
  const dateFormat = userLocale !== 'en-US' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';

  const onChangeHandler = (name: string, date: Moment) => {
    // Check if date is valid
    if (date && moment.isMoment(date) && date.isValid() && !isError) {
      const formattedDate = date.format(dateFormat);
      // setLocalValue(formattedDate);
      onchange(name, date);
    }
  };

  return (
    <LocalizationProvider dateAdapter={MomentUtils}>
      <InputLabel htmlFor={id} sx={{ mb: 0.5, fontSize: 15 }}>
        {label}
      </InputLabel>

      <DatePicker
        value={value && moment(value, 'YYYY-MM-DD', true).isValid() ? moment(value, 'YYYY-MM-DD') : null}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        disabled={disabled}
        minDate={min ? moment(min) : null}
        maxDate={max ? moment(max) : null}
        inputFormat={dateFormat}
        toolbarPlaceholder={placeholder}
        className="datepicker-custom"
        onChange={(date: unknown) => onChangeHandler(name, date as Moment)}
        renderInput={(params) => (
          <TextField
            {...params}
            id={id}
            disabled={disabled}
            required={required}
            error={isError}
            // helperText={textErrorHelper}
            fullWidth
            variant={variant}
            sx={{
              '& .MuiInputBase-root': {
                height: 38, // 🔥 reduced height
                fontSize: 14,
                paddingRight: 0,
              },
              '& .MuiInputBase-input': {
                padding: '6px 8px', // 🔥 reduced spacing between text & border
                fontSize: 14,
              },
              '& .MuiInputLabel-root': { fontSize: 15 },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="start" sx={{ mb: '20px !important' }}>
                  <IconButton
                    edge="end"
                    onClick={handleOpen}
                    size="small"
                    color="primary"
                    sx={{
                      padding: 0,
                      '& svg': {
                        fontSize: 16, // 🔥 perfect icon size
                      },
                    }}
                  >
                    <CalendarIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};
export default InputDate;
